import React, { useState, useEffect } from 'react';
import { DialogContent, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  StyledDialog,
  StyledDialogTitle,
  CloseButton,
  DescriptionText,
  StyledLabel,
  StyledTextField,
  HelperText,
  StyledDialogActions,
  CancelButton,
  SubmitButton
} from './styles';

interface SetWorkerPayProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { workerPay: string; facilityCharge: string }) => void;
  initialWorkerPay?: string;
  initialFacilityCharge?: string;
}

const SetWorkerPay: React.FC<SetWorkerPayProps> = ({
  open,
  onClose,
  onSubmit,
  initialWorkerPay = '',
  initialFacilityCharge = ''
}) => {
  const [workerPay, setWorkerPay] = useState(initialWorkerPay);
  const [facilityCharge, setFacilityCharge] = useState(initialFacilityCharge);

  // Reset state when dialog opens
  useEffect(() => {
    if (open) {
      setWorkerPay(initialWorkerPay === 'null' || !initialWorkerPay ? '0' : initialWorkerPay);
      setFacilityCharge(initialFacilityCharge === 'null' || !initialFacilityCharge ? '0' : initialFacilityCharge);
    }
  }, [open, initialWorkerPay, initialFacilityCharge]);

  const handleSubmit = () => {
    onSubmit({ workerPay, facilityCharge });
  };

  const handleInputChange = (setter: React.Dispatch<React.SetStateAction<string>>) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Allow only numbers and one decimal point
    if (/^\d*\.?\d*$/.test(value)) {
      setter(value);
    }
  };

  return (
    <StyledDialog open={open} onClose={onClose}>
      <StyledDialogTitle>
        Set Worker Pay
        <CloseButton onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      </StyledDialogTitle>
      <DescriptionText>
        Enter the worker’s pay and the facility charge.
      </DescriptionText>
      <DialogContent sx={{ padding: 0 }}>


        <StyledLabel>Worker Pay</StyledLabel>
        <StyledTextField
          placeholder="0.00"
          value={workerPay}
          onChange={handleInputChange(setWorkerPay)}
          fullWidth
          autoComplete="off"
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
        <HelperText>Worker’s salary</HelperText>

        <StyledLabel>Facility Charge</StyledLabel>
        <StyledTextField
          placeholder="0.00"
          value={facilityCharge}
          onChange={handleInputChange(setFacilityCharge)}
          fullWidth
          autoComplete="off"
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
        <HelperText>Facility rate for worker</HelperText>
      </DialogContent>
      <StyledDialogActions>
        <CancelButton onClick={onClose} variant="outlined">
          Cancel
        </CancelButton>
        <SubmitButton
          onClick={handleSubmit}
          variant="contained"
          disableElevation
          // Disable if fields are empty? Or just let validation handle it. 
          // Assuming required as per typical form behavior.
          disabled={!workerPay || !facilityCharge}
        >
          Submit
        </SubmitButton>
      </StyledDialogActions>
    </StyledDialog>
  );
};

export default SetWorkerPay;
